(function(){
"use strict";
/* Il blocco promozionale va inserito dentro il menu a tendina del
   tema, che viene disegnato dal tema stesso: lo agganciamo dopo
   l'elenco delle voci, senza toccare i file del tema.
   In piu' evidenziamo la serie piu' recente con una pastiglia. */

var SERIE_NUOVA = "iphone-serie-17";   /* cambia qui a ogni uscita */
var ETICHETTA   = "Novit\u00e0";

function metti(){
 var sorgente=document.getElementById("dmenuSorgente");
 if(sorgente){
  var cassetti=document.querySelectorAll(".menu-drawer__navigation");
  for(var i=0;i<cassetti.length;i++){
   var c=cassetti[i];
   if(c.querySelector(".dmenu"))continue;
   var elenco=c.querySelector(".menu-drawer__menu");
   if(!elenco)continue;
   elenco.parentNode.insertBefore(sorgente.content.cloneNode(true),elenco.nextSibling);
  }
 }
 evidenzia();
}

/* pastiglia "Novita'" accanto alla voce della serie piu' recente,
   sia nel menu principale sia nei sottomenu */
function evidenzia(){
 var voci=document.querySelectorAll(".menu-drawer a, .header__menu-item, .header__submenu a");
 for(var i=0;i<voci.length;i++){
  var a=voci[i];
  var href=(a.getAttribute("href")||"").toLowerCase();
  var testo=(a.textContent||"").toLowerCase();
  var eLaNuova = href.indexOf(SERIE_NUOVA)!==-1 ||
                 (testo.indexOf("serie 17")!==-1) ||
                 (testo.trim()==="17");
  if(!eLaNuova)continue;
  if(a.querySelector(".dnovita"))continue;
  var p=document.createElement("span");
  p.className="dnovita";
  p.textContent=ETICHETTA;
  a.appendChild(p);
 }
}

if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",metti);
else metti();
addEventListener("load",metti);

document.addEventListener("click",function(e){
 if(e.target.closest(".header__icon--menu, .menu-drawer__close-button, .menu-drawer__menu-item"))setTimeout(metti,120);
});
setTimeout(metti,900);
setTimeout(evidenzia,1800);
})();
